import React from 'react'
import { useEffect } from 'react'

function useDangerGoods(initialLength = 0, depArray = [], set = true) {
  const [goods, setGoods] = React.useState(1)

  useEffect(() => {
    if (set) setGoods(initialLength)
  }, depArray)

  return [goods, setGoods]
}
export default useDangerGoods
